/*
=========================================================
* Call It In LLC - [Component Name]
=========================================================

* Company: Call It In LLC
* Website: https://www.justcallitin.com
* Author: Shaun Matthews
* Copyright: © 2025 Call It In LLC. All rights reserved.

=========================================================
* This file is part of the Call It In dashboard system.
* Any reproduction or distribution without written consent is strictly prohibited.
=========================================================
*/

import pxToRem from "assets/theme/functions/pxToRem";

import colors from "assets/theme/base/colors";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";

const { transparent } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      backgroundColor: transparent.main,
      boxShadow: lg,
      padding: pxToRem(8),
      borderRadius: borderRadius.md,
    },
  },
};

export default popover;
